import type { NuxtApp } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  const { $logger } = nuxtApp as NuxtApp;
  const routeName = useRoute().name;
  const isAmp = routeName === 'article-amp';

  $logger('✂︎ is-amp-plugin', { isAmp, routeName });
  nuxtApp.provide('isAMP', isAmp);
  nuxtApp.vueApp.provide('isAMP', isAmp);
});
